// src/AppNavigatorBinder.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { bindMediaNavigator, unbindMediaNavigator } from "@/lib/mediaHub";

/**
 * Route binder: ensures programmatic navigation works everywhere.
 * Mount exactly once under your Router (e.g., in AppShell above <Outlet />).
 */
export default function AppNavigatorBinder() {
  const navigate = useNavigate();

  React.useEffect(() => {
    bindMediaNavigator(navigate);
    return () => unbindMediaNavigator();
  }, [navigate]);

  return null;
}
